'use client'

import { MCheckbox } from '@/_components/medante/m-checkbox'
import { MTextarea } from '@/_components/medante/m-textarea'
import { Link } from '@/_i18n/routing'

import { ERR } from '../_utils/patient-form.constants'

import { APatientInfoSectionHeading } from './a-patient-info-section-heading'

import type { PatientFormValues } from '../_types/patient-form.types'
import type { FieldErrors, UseFormRegister } from 'react-hook-form'

type APatientInfoMessageConsentsSectionProps = {
	register: UseFormRegister<PatientFormValues>
	errors: FieldErrors<PatientFormValues>
}

export function APatientInfoMessageConsentsSection({
	register,
	errors
}: APatientInfoMessageConsentsSectionProps) {
	return (
		<section className='mb-8'>
			<APatientInfoSectionHeading>
				Dodatočné informácie k objednávke
			</APatientInfoSectionHeading>
			<div className='mb-3'>
				<MTextarea label='Správa' registration={register('message')} />
			</div>

			<div className='space-y-3'>
				<MCheckbox
					error={errors.privacyPolicy?.message}
					registration={register('privacyPolicy', {
						required: ERR.privacyPolicy
					})}
				>
					Oboznámil/a som sa a súhlasím s:{' '}
					<Link href='/legal/gdpr' prefetch={false} target='_blank' className='underline'>
						Ochrana osobných údajov
					</Link>
					.
				</MCheckbox>

				<MCheckbox
					error={errors.terms?.message}
					registration={register('terms', { required: ERR.terms })}
				>
					Oboznámil/a som sa a súhlasím s:{' '}
					<Link href='/legal/vop' prefetch={false} target='_blank' className='underline'>
						Všeobecné obchodné podmienky
					</Link>
					.
				</MCheckbox>

				<MCheckbox registration={register('marketing')}>
					Oboznámil/a som sa a súhlasím so:{' '}
					<Link
						href='/legal/marketing-consent'
						prefetch={false}
						target='_blank'
						className='underline'
					>
						Súhlas so spracúvaním osobných údajov na marketingové účely
					</Link>
				</MCheckbox>
			</div>
		</section>
	)
}
